/**
 * Application configuration
 *
 * This file contains configuration settings for the application.
 * Centralizing these values makes it easier to change them in the future.
 */

// API endpoints
export const API_BASE_URL = "https://api.dev.c2fit.aimet.tech";
export const API_LOGIN_ENDPOINT = `${API_BASE_URL}/api/v1/auth/login/email`;
export const API_WEBSOCKET_ENDPOINT = `wss://api.dev.c2fit.aimet.tech/ws/v1/speech`;

// WebSocket configuration
export const WEBSOCKET_TIMEOUT_MS = 5000; // 5 seconds

// Audio recording configuration
export const AUDIO_SAMPLE_RATE = 16000;
export const AUDIO_CHANNELS = 1;
export const AUDIO_BUFFER_SIZE = 1024;

// UI configuration
export const LONG_RECORDING_WARNING_SECONDS = 300; // 5 minutes
